<template>
  <small-modal
    :fit-content="true"
    :show-close-button="false"
    class="sorting-modal"
    @close="$emit('close-sorting-modal')"
  >
    <div class="video-sorting-container">
      <h1 class="order-by">{{ $t("campaignManager.sort") }}</h1>
      <span class="reset" @click="sortVideos(null, true)">{{
        $t("campaignManager.filter.reset")
      }}</span>
      <div class="sorting-wrapper">
        <div
          v-for="option in sortingOptions"
          :key="option.key"
          class="sorting-options"
        >
          <div class="sorting-option">
            <h2
              class="sorting-type-title"
              :class="{ 'sort-selected': selectedSorting === option.key }"
              @click="toggleSortDirection(option.key)"
            >
              {{ option.label }}
            </h2>
            <div class="sorting-arrows">
              <SortArrow
                class="sort-arrow"
                :class="{
                  'arrow-selected':
                    selectedSorting === option.key && selectedOrder === 'asc',
                }"
                @click.stop="sortVideos(option.key, true)"
              />
              <SortArrow
                class="sort-arrow reverse-arrow"
                :class="{
                  'arrow-selected':
                    selectedSorting === option.key && selectedOrder === 'desc',
                }"
                @click.stop="sortVideos(option.key, false)"
              />
            </div>
          </div>
          <div class="separation-line"></div>
        </div>
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import SortArrow from "@/assets/svg/sort-arrow.svg?inline";

export default {
  name: "VideoSortingModal",
  components: { SmallModal, SortArrow },
  data() {
    return {
      selectedSorting: null,
      selectedOrder: null,
      sortingOptions: [
        {
          key: "creationDate",
          label: this.$t("create.step2.videoSortModal.import"),
        },
        {
          key: "duration",
          label: this.$t("create.step2.videoSortModal.duration"),
        },
        {
          key: "views",
          label: this.$t("create.step2.videoSortModal.7daysViews"),
        },
        {
          key: "productsCount",
          label: this.$t("create.step2.videoSortModal.products"),
        },
      ],
    };
  },
  methods: {
    sortVideos(key, asc) {
      this.selectedSorting = key;
      this.selectedOrder = asc ? "asc" : "desc";
      this.$emit("sort", { sortType: key, isAscending: asc });
    },
    toggleSortDirection(key) {
      if (this.selectedSorting === key) {
        this.sortVideos(key, this.selectedOrder !== "asc");
      } else {
        this.sortVideos(key, true);
      }
    },
  },
};
</script>

<style lang="scss">
.sorting-modal .small-modal.fit-modal {
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  padding: 16px;
  top: 130px;
  left: 40%;
  transform: translate(0, 0);
  border: 1px solid rgba(196, 196, 196, 1);
}
</style>

<style lang="scss" scoped>
.modal-background {
  background: transparent;
  width: 100% !important;
}
.order-by {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 14px;
}
.reset {
  font-size: 10px;
  cursor: pointer;
  position: fixed;
  top: 16px;
  right: 16px;
}
.sorting-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sorting-options {
  display: flex;
  flex-direction: column;
}
.sorting-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sorting-type-title {
  &:hover {
    cursor: pointer;
  }
}
.sorting-arrows {
  display: flex;
  flex-direction: column;
  gap: 4px;
  transform: scale(70%);
  .reverse-arrow {
    transform: translateX(-0.9px) rotate(180deg);
  }
}
.arrow-selected path {
  fill: $dark-purple;
}
.sort-selected {
  color: $dark-purple;
}
.separation-line {
  height: 1px;
  background: $light-grey;
  margin-top: 8px;
}
</style>
